'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import MovementRegistrationPopup from '@/components/common/MovementRegistrationPopup';

const CTASection: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <section className="py-20 bg-gradient-to-br from-primary via-secondary to-accent">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <Icon name="HeartIcon" size={64} className="text-white mx-auto mb-8 pulse-gentle" />
        <h2 className="text-3xl lg:text-5xl font-headline font-bold text-white mb-6">
          Join the Movement
        </h2>
        <p className="text-xl text-white/90 font-body leading-relaxed mb-12 max-w-3xl mx-auto">
          Every journey of transformation begins with a single choice. Choose to live with no enemy. Choose peace. Choose healing.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => setShowPopup(true)}
            className="px-8 py-4 bg-white text-primary rounded-lg font-cta text-lg font-bold transition-all duration-300 hover:scale-105 hover:shadow-xl inline-flex items-center justify-center space-x-2"
          >
            <span>Begin Your Journey</span>
            <Icon name="ArrowRightIcon" size={20} />
          </button>
          <Link
            href="/festival-guide"
            className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg font-cta text-lg font-bold transition-all duration-300 hover:bg-white hover:text-primary inline-flex items-center justify-center space-x-2"
          >
            <span>Explore Festival Guide</span>
            <Icon name="CalendarIcon" size={20} />
          </Link>
        </div>
      </div>

      {showPopup && (
        <MovementRegistrationPopup
          sourcePage="the-movement-cta"
          isOpen={showPopup}
          onClose={() => setShowPopup(false)}
        />
      )}
    </section>
  );
};

export default CTASection;